import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import moment from "moment";
import { parseMessage } from "../../utils/messageParser";
import "./Message.scss";

export interface Message {
  id: string;
  text: string;
  sender: "user" | "assistant";
  timestamp: Date;
}

interface MessageProps {
  message: Message;
}

const Message: React.FC<MessageProps> = ({ message }) => {
  const isUser = message.sender === "user";
  const isLoading = message.id.startsWith("loading-");
  // Convert UTC timestamp to local time for display
  const formattedTime = moment(message.timestamp).format("h:mm A");

  return (
    <div className={`chatbot-message ${isUser ? "message-user" : "message-assistant"}`}>
      <div className="message-content">
        <div className="message-avatar">
          <Iconography
            icon={isUser ? "user" : "userHeadset"}
            size={IconographySizes.Medium}
          />
        </div>
        <div className="message-bubble">
          {isLoading ? (
            <div className="message-loading-dots">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          ) : (
            <p className="message-text">{parseMessage(message.text)}</p>
          )}
          {!isLoading && <span className="message-timestamp">{formattedTime}</span>}
        </div>
      </div>
    </div>
  );
};

export default Message;

